import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/layout/layout-dashboard';
import { supabase } from '../../lib/supabase';
import { useNavigate } from 'react-router-dom';

export default function TimelineCampagnesPage() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const checkAdmin = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          navigate('/');
          return;
        }

        const { data: userData, error } = await supabase
          .from('users')
          .select('role')
          .eq('id', user.id)
          .maybeSingle();

        if (error || !userData || userData.role !== 'admin') {
          console.error('Error fetching user role or user is not admin:', error);
          navigate('/');
          return;
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        navigate('/');
      }
    };

    checkAdmin();
  }, [navigate]);

  return (
    <Layout>
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>
      <div className="container-custom py-12">
        <h1 className="text-4xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
          Timeline Campagnes
        </h1>
        <div className="bg-white rounded-xl shadow-lg p-8">
          <p className="text-lg text-neutral-600">
            Visualisez et gérez vos campagnes de recrutement en cours.
          </p>
        </div>
      </div>
    </Layout>
  );
}